import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout is provided once by the parent _authenticated route so it persists across
// navigation (workspace <-> org-admin); this route only adds the $workspaceId segment.
export const Route = createFileRoute(
	"/_authenticated/$orgSlug/workspaces/$workspaceId",
)({
	component: () => <Outlet />,
});
